import Moment from "moment-jalaali";

Moment.loadPersian({ dialect: "persian-modern" });

export function durationToHuman(duration?: any) {
  return Moment.duration(duration, "seconds").humanize();
}

export function momentToJalaliWithTime(moment: any = Moment()) {
  return moment.format("hh:mm - jYYYY/jMM/jDD");
}

export function momentToJalali(moment: any = Moment()) {
  return moment.format("jYYYY/jMM/jDD");
}

export function momentToCurrentMonthName(moment: any = Moment()) {
  return moment.locale("fa").format("jMMMM");
}

export function momentToSpecialJalali(moment: any = Moment()) {
  return moment.format("dddd jD jMMMM jYYYY ، HH:mm");
}

export function momenToRegular(moment: any = Moment()) {
  return moment.format("YYYY/MM/DD");
}

export function momentToRegularWithTime(moment: any = Moment()) {
  return moment.format("hh:mm - YYYY/MM/DD");
}

export function momentToReqgularTime(moment: any = Moment()) {
  return moment.format("hh:mm");
}

export function momentToReqgularTimeWithSecound(moment: any = Moment()) {
  return moment.format("hh:mm:ss");
}

export function momentToRegularWithTimeSwapped(moment: any = Moment()) {
  return moment.format("jYYYY-jMM-jDD hh:mm:ss");
}

export function miladiToJalali(date: Date | string, locale?: string) {
  return locale !== "fa" ? momenToRegular(Moment(date)) : momentToJalali(Moment(date));
}

export function miladiToJalaliSpecial(date: Date) {
  return momentToSpecialJalali(Moment(date));
}

export function miladiToJalaliWithTime(date: Date, locale?: string) {
  return locale !== "fa"
    ? momentToRegularWithTime(Moment(date))
    : momentToJalaliWithTime(Moment(date));
}

export function miladiToJalaliTime(date: Date) {
  return momentToReqgularTime(Moment(date));
}

export function miladiToJalaliWithTimeSwapped(date: Date) {
  return momentToRegularWithTimeSwapped(Moment(date));
}

export function dateToMoment(date: any) {
  return Moment(date);
}

export function getDiffFromNowUnix(time: any) {
  const now = Moment();
  return time - now.unix();
}
